import api from '@/api'
import { JSConn } from '@/utilities/js-conn.js'
import fromApi from '@/api/map-to-frontend'
// import { getUserCompanyData } from '@/api/company-data'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'
import { errorPipeline } from '@/api/pipelines/error-pipeline.js'

export default {
  name: 'VerifyEmailForm',
  data () {
    return {
      email: null,
      token: null
    }
  },
  created () {
    const jsConn = new JSConn()
    // const queryParams = this.$route.query
    jsConn.formParams = {
      email: this.$route.query.email,
      token: this.$route.query.token
    }
    // post the parameters
    api.verifyEmail(jsConn)
      .then((jsConn) => {
        if (jsConn.apiCallStatus === 'success') {
          successPipeline(jsConn)
            .then(jsConn => {
              // email successfully verified
              // log the user in
              // check what response we got back and make the necessary steps
              const dataForStore = fromApi.userToStore(jsConn.response['data']['payload'])
              this.$store.dispatch('updateSession', dataForStore)
              this.$router.push('/subscription')

              // getUserCompanyData(jsConn)
              //   .then(jsConn => {
              //     console.log('the data was picked up')
              //     // route user to the credit card page
              //     this.$router.push('/subscription')
              //   })
            })
            .catch(jsConn => {
              return Promise.reject(jsConn)
            })
        } else {
          errorPipeline(jsConn)
            .then(jsConn => {
              this.$router.push('/sign-up')
            })
        }
      })
  }
}
